import cn from "@utils/cn";

import ModalCancelButton from "@components/modal/ModalCancelButton";

const CLASS_NAMES = cn(`
  flex
  items-center
  justify-end
  gap-2
  px-5
  py-3
  border-t

  bg-gallery-200
  border-gallery-300
`);

export default function ModalFooter(props) {
  return (
    <footer className={CLASS_NAMES}>
      {props.children || (
        <ModalCancelButton onClick={props.onClickCancelButton} />
      )}
    </footer>
  );
}
